import { Drawer } from '@liveauctioneers/hammer-ui-core/drawer';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Bell, SlidersHorizontal } from '@liveauctioneers/hammer-ui-core/icons';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MyFavoritesSlideMenu from '@/pages/MyItems/MyFavorites/components/MyFavoritesSlideMenu/MyFavoritesSlideMenu';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getNotificationsUrl } from '@/utils/urls';

type Props = {
    buttonClassName?: string;
};

/** Mobile favorites filters + Manage Notifications: a filter button that opens a right-side drawer. */
export const MyFavoritesFilterDrawer = ({ buttonClassName }: Props) => {
    const navigate = useNavigate();
    const formatMessage = useAppFormatMessage();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const manageUrl = getNotificationsUrl('searches');

    return (
        <>
            <IconButton
                className={buttonClassName}
                icon={SlidersHorizontal}
                onClick={() => {
                    setIsDrawerOpen(true);
                }}
            />
            <Drawer
                actions={
                    <SubtleMonochromeLink
                        href={manageUrl}
                        id="manageNotifications"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsDrawerOpen(false);
                            window.requestAnimationFrame(() => {
                                navigate(manageUrl);
                            });
                        }}
                    >
                        <InlineButton
                            icon={Bell}
                            size="sm"
                            style="neutral"
                        >
                            {formatMessage(['manageNotifications'])}
                        </InlineButton>
                    </SubtleMonochromeLink>
                }
                anchor="right"
                closeOnOutsideClick
                density="comfortable"
                handleClose={() => {
                    setIsDrawerOpen(false);
                }}
                hasShadow
                headerText={formatMessage(['favorites', 'favorite_items'])}
                show={isDrawerOpen}
                size="narrow"
            >
                <MyFavoritesSlideMenu />
            </Drawer>
        </>
    );
};
